import { sendWsLottery } from './index';

// 获取彩票大厅数据
export const getLotteryHotList = () => {
    return sendWsLottery({
        method: 'get',
        url: '/official/lottery/game/lotteryHotList',
    });
};

// 获取彩种列表
export const findLotteryList = (categoryCode: number, cancelExecutor?: (cancel: () => void) => void) => {
    return sendWsLottery(
        {
            method: 'get',
            url: `/official/lottery/game/findLotteryList/${categoryCode}`,
        },
        cancelExecutor
    );
};

// 获取PC侧边栏树形菜单
export const findCategoryTree = () => {
    return sendWsLottery({
        method: 'get',
        url: '/official/lottery/game/findAll',
    });
};

// 玩法列表
export const findCurrentExpect = (gameCode: number) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/expect/findCurrentExpect/${gameCode}`,
    });
};

// 获取投注记录
export const findBetHistoryPage = (data: any, current: number, size: number) => {
    return sendWsLottery({
        method: 'post',
        url: `/official/lottery/bet/findPage/${current}/${size}`,
        data,
    });
};

// 获取追号投注记录
export const findTraceBetHistoryPage = (data: any, current: number, size: number) => {
    return sendWsLottery({
        method: 'post',
        url: `/official/lottery/betContinue/findPage/${current}/${size}`,
        data,
    });
};

// 根据订单号查询投注记录
export const findByOrderNo = (orderNo: string) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/bet/findByOrderNo/${orderNo}`,
    });
};

// 根据订单号查询投注记录
export const findTraceByOrderNo = (orderNo: string) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/betContinue/findByOrderNo/${orderNo}`,
    });
};

// 根据订单号查询追号投注记录
export const findByBetContinueOrderNo = (orderNo: string) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/betContinue/findByOrderNo/${orderNo}`,
    });
};

// 获取近期开奖记录
export const findTopWithDetailList = (gameCode: number, top: number, data: any) => {
    return sendWsLottery({
        method: 'post',
        url: `/official/lottery/openCode/findTopWithDetailList/${gameCode}/${top}`,
        data,
    });
};

// 开奖历史列表
export const findNetOpenCodeList = () => {
    return sendWsLottery({
        method: 'get',
        url: '/official/lottery/openCode/findNetOpenCodeList',
    });
};

// 获取生肖
export const findZodiac = () => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/play/zodiac`,
    });
};

// 获取开奖记录
export const findOpenCodePage = (data: any, current: number, size: number) => {
    return sendWsLottery({
        method: 'post',
        url: `/official/lottery/openCode/findPage/${current}/${size}`,
        data,
    });
};

// 获取最新期号
export const findSmallCurrentExpect = (gameCode: number) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/expect/findSmallCurrentExpect/${gameCode}`,
    });
};

// 获取最新期号PC
export const findPcSmallCurrentExpect = (gameCode: number) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/expect/findPcSmallCurrentExpect/${gameCode}`,
    });
};

// 获取生肖
export const getZodiac = () => {
    return sendWsLottery({
        method: 'get',
        url: '/official/lottery/play/zodiac',
    });
};

// 获取彩票规则
export const getPlayRule = (code: any) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/play/findPlayRule/${code}`,
    });
};

// 获取追号期号
export const getExpectList = (params: any) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/expect/findExpectList/${params?.gameCode}/${params?.expect}/${params?.type}/${params?.top}`,
    });
};

// 获取彩票首页轮播图
export const getLotteryAdsList = () => {
    return sendWsLottery({
        method: 'get',
        url: `/content/contentAds/officialLotteryAds`,
    });
};

// 获取投注未结算和输赢
export const getFindBetTotal = (data = {}) => {
    return sendWsLottery({
        method: 'post',
        url: `/official/lottery/bet/findBetTotal`,
        data,
    });
};

// 获取长龙列表
export const getFindChangLong = (params = {}) => {
    return sendWsLottery({
        method: 'get',
        url: `/official/lottery/play/findChangLong`,
        params,
    });
};
